module.exports = __webpack_public_path__ + "static2023-4-17/img/init.dc67a8fe.png";